import { UserManager, WebStorageStateStore } from "oidc-client-ts";

// TODO - https://github.com/Yugen-ai/canso-fraud-investigation-ui/issues/180
export const userManager = new UserManager({
  authority: window.IDP_AUTHORITY,
  client_id: window.AUTH_CLIENT_ID,
  redirect_uri: `${window.location.origin}${window.location.pathname}`,
  post_logout_redirect_uri: window.location.origin,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  monitorSession: true, // this allows login/logout detection across tabs
});

export const onSigninCallback = () => {
  window.history.replaceState({}, document.title, window.location.pathname);
};